import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../components/common/icon/Icon';
import { IWholesaleMarket, wholesaleMarketConstants } from '../../../constants/cropTrends/wholesaleMarket.constant';
import { SelectPicker } from '../../../components/common/inputs/SelectPicker';
import { ampli } from '../../../ampli';

interface WholesaleMarketSelectButtonProps {
  currentMarket: IWholesaleMarket;
  handleMarketChange: (market: IWholesaleMarket) => void;
  page: 'list' | 'detail';
}

export const WholesaleMarketSelectButton = ({
  currentMarket,
  handleMarketChange,
  page,
}: WholesaleMarketSelectButtonProps) => {
  const [isMarketPickerVisible, setIsMarketPickerVisible] = useState<boolean>(false);

  const handleButtonClick = () => {
    if (page === 'list') {
      ampli.pvmClickCropListSelectMarketButton();
    }

    setIsMarketPickerVisible(true);
  };

  const wholesaleMarketListForSelect = [
    {
      code: 'all',
      name: '도매시장 전체',
    },
    ...wholesaleMarketConstants,
  ];

  const transformedMarketsForPicker = wholesaleMarketListForSelect.map((market) => {
    return {
      label: market.name,
      value: market.code,
    };
  });

  return (
    <>
      <Container onClick={handleButtonClick}>
        <ButtonText>{currentMarket.name}</ButtonText>
        <Icon name={'AngleDown'} size={'Small'} fill={'#898B94'} />
      </Container>

      <SelectPicker
        columns={[transformedMarketsForPicker]}
        visible={isMarketPickerVisible}
        onConfirm={(selectedMarket, extendSeletedMarketValue) => {
          const selectedMarketCode = extendSeletedMarketValue.items[0]?.value as string;
          const selectedMarketName = extendSeletedMarketValue.items[0]?.label as string;

          if (page === 'list') {
            ampli.pvmCropListMarketFilterChange({
              market: selectedMarketName,
            });
          } else {
            ampli.pvmCropDetailMarketFilterChange({
              market: selectedMarketName,
            });
          }

          handleMarketChange({
            code: selectedMarketCode,
            name: selectedMarketName,
          });
        }}
        onClose={() => setIsMarketPickerVisible(false)}
      />
    </>
  );
};

const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px 16px;
  gap: 4px;

  border-radius: var(--radius-round, 80px);
  background-color: #f2f2f7;
`;

const ButtonText = styled.div`
  color: '#232429';
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */

  white-space: nowrap;
`;
